import { createStyles } from '@material-ui/styles';

const styles = (): any =>
    createStyles({
        page: {
            position: 'absolute',
        },
        toolBar: {},
        appBar: {
            backgroundColor: '#fff',
        },
    });

export default styles;
